// src/App.js
import React, {useContext} from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { Nav, NavLink, NavLinks, LoginButton } from './components/StyledNav';
import ProfileIcon from './components/ProfileIcon';
import { AuthContext } from './AuthContext';

function App() {
  const { isLoggedIn, user } = useContext(AuthContext);

  const userClaims = user?.operationClaims || [];
  const isAdmin = userClaims.includes('admin');
  const canCreatePost = isAdmin || userClaims.includes('createPost');

  return (
    <Router>
      <Nav>
        <NavLinks>
          <NavLink to="/">Home</NavLink>
          {canCreatePost && (<NavLink to="/new-post">New Post</NavLink>)}
          <NavLink to="/posts">Posts</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          {/* Add more NavLink components as needed */}
        </NavLinks>

        { !isLoggedIn ? (
          <LoginButton to="/login">Login</LoginButton>
        ) : (
          // This clickable component will lead to /account
          <ProfileIcon
            to="/account"
            username={user?.username || 'EconoVerse'}
          />
        )}

      </Nav>
      <AppRoutes />
    </Router>
  );
}

export default App;
